import { useCallback, useState } from "react";

export function useErrorModal() {
  const [errorMessage, setErrorMessage] = useState("");

  const showError = useCallback((message) => {
    setErrorMessage(String(message || "Something went wrong."));
  }, []);

  const closeError = useCallback(() => {
    setErrorMessage("");
  }, []);

  return {
    errorMessage,
    isErrorOpen: Boolean(errorMessage),
    showError,
    closeError,
  };
}